import { render, staticRenderFns } from "./smallbox.vue?vue&type=template&id=196fbe53&scoped=true"
import script from "./smallbox.vue?vue&type=script&lang=js"
export * from "./smallbox.vue?vue&type=script&lang=js"
import style0 from "./smallbox.vue?vue&type=style&index=0&id=196fbe53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196fbe53",
  null
  
)

export default component.exports